var _style, _g, _g2, _g3, _g4, _path, _polygon, _polygon2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 561.26",
    style: {
      enableBackground: "new 0 0 595.28 561.26"
    },
    xmlSpace: "preserve",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M555.31,1313.08c-0.43,20.33-17.04,36.59-37.38,36.61l-35.08,0.04l-0.26-243.69l-111.06,0.12l-10.08,0.16l-34.17,81.99 l-33.89-80.74l-25.17,0.48l-0.02-15.9c-0.03-24.39,19.73-44.17,44.1-44.2l163.14-0.18c0,0,74.17,5.23,78.69,90.86 C557.09,1195.33,556.23,1269.46,555.31,1313.08z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405.86,1188.22l0.17,162.12c0.03,29.93-24.21,54.23-54.16,54.26l-166.52,0.18c-49.45-1.69-71.6-67.02-71.6-67.02 l-0.19-172.08c-0.03-31.75,25.68-57.51,57.43-57.54l17.56-0.02l-0.63,241.92l67.98-0.07l-1.03-161.59l59.27,119.15l31.79-0.03 L405.86,1188.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M199.84,1484.58h-9.95v-23.87l-17.75,23.26l-17.75-23.26v23.87h-9.95v-39.2h10.45l17.25,22.65l17.33-22.65h10.37V1484.58z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.94,1472.49c0,3.29-1.08,6.11-3.23,8.44c-2.32,2.43-5.25,3.65-8.79,3.65H231.1v-9.15h36.82 c1.38,0,2.07-0.98,2.07-2.94c0-1.96-0.69-2.94-2.07-2.94h-26.78c-3.54,0-6.47-1.22-8.79-3.66c-2.21-2.29-3.32-5.08-3.32-8.39 c0-3.3,1.13-6.15,3.4-8.54c2.27-2.39,5.17-3.58,8.71-3.58h36.82v9.15h-36.9c-1.38,0-2.08,0.99-2.08,2.97c0,1.93,0.69,2.9,2.08,2.9 h26.84c3.54,0,6.48,1.22,8.81,3.65C278.86,1466.39,279.94,1469.2,279.94,1472.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.52,1484.58h-9.95v-23.87l-17.75,23.26l-17.75-23.26v23.87h-9.95v-39.2h10.45l17.25,22.65l17.33-22.65h10.36V1484.58z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.04,1484.58h-9.95v-12.43h-26.2V1463h26.2v-5.49c0-1.98-0.72-2.97-2.16-2.97h-28.19c-1.38,0-2.07,0.99-2.07,2.97 v27.08h-9.95v-27.1c0-3.3,1.12-6.14,3.36-8.52c2.24-2.38,5.13-3.58,8.67-3.58h28.19c3.59,0,6.51,1.19,8.75,3.58 c2.24,2.39,3.36,5.23,3.36,8.52V1484.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.31,1484.58h-13.6l-21.31-21.96h25.62c1.82,0,2.74-1.35,2.74-4.04c0-2.69-0.91-4.04-2.74-4.04h-30.85v30.05h-9.95 v-39.2h41.38c3.81,0,6.83,1.37,9.04,4.12c2.04,2.49,3.07,5.52,3.07,9.07c0,3.56-1.02,6.58-3.07,9.08 c-2.21,2.75-5.22,4.12-9.04,4.12h-3.81L525.31,1484.58z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1548.38,1313.08c-0.43,20.33-17.04,36.59-37.38,36.61l-35.08,0.04l-0.26-243.69l-111.06,0.12l-10.08,0.16 l-34.17,81.99l-33.89-80.74l-25.17,0.48l-0.02-15.9c-0.03-24.39,19.73-44.17,44.1-44.2l163.14-0.18c0,0,74.17,5.23,78.69,90.86 C1550.16,1195.33,1549.3,1269.46,1548.38,1313.08z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1398.93,1188.22l0.17,162.12c0.03,29.93-24.21,54.23-54.16,54.26l-166.52,0.18 c-49.45-1.69-71.6-67.02-71.6-67.02l-0.19-172.08c-0.03-31.75,25.68-57.51,57.43-57.54l17.56-0.02l-0.63,241.92l67.98-0.07 l-1.03-161.59l59.27,119.15l31.79-0.03L1398.93,1188.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1192.91,1484.58h-9.95v-23.87l-17.75,23.26l-17.75-23.26v23.87h-9.95v-39.2h10.45l17.25,22.65l17.33-22.65 h10.37V1484.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1273.01,1472.49c0,3.29-1.08,6.11-3.23,8.44c-2.32,2.43-5.25,3.65-8.79,3.65h-36.82v-9.15h36.82 c1.38,0,2.07-0.98,2.07-2.94c0-1.96-0.69-2.94-2.07-2.94h-26.78c-3.54,0-6.47-1.22-8.79-3.66c-2.21-2.29-3.32-5.08-3.32-8.39 c0-3.3,1.13-6.15,3.4-8.54c2.27-2.39,5.17-3.58,8.71-3.58h36.82v9.15h-36.9c-1.38,0-2.08,0.99-2.08,2.97c0,1.93,0.69,2.9,2.08,2.9 h26.84c3.54,0,6.48,1.22,8.81,3.65C1271.93,1466.39,1273.01,1469.2,1273.01,1472.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1357.59,1484.58h-9.95v-23.87l-17.75,23.26l-17.75-23.26v23.87h-9.95v-39.2h10.45l17.25,22.65l17.33-22.65 h10.36V1484.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1439.1,1484.58h-9.95v-12.43h-26.2V1463h26.2v-5.49c0-1.98-0.72-2.97-2.16-2.97h-28.19 c-1.38,0-2.07,0.99-2.07,2.97v27.08h-9.95v-27.1c0-3.3,1.12-6.14,3.36-8.52c2.24-2.38,5.13-3.58,8.67-3.58H1427 c3.59,0,6.51,1.19,8.75,3.58c2.24,2.39,3.36,5.23,3.36,8.52V1484.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1518.38,1484.58h-13.6l-21.31-21.96h25.62c1.82,0,2.74-1.35,2.74-4.04c0-2.69-0.91-4.04-2.74-4.04h-30.85 v30.05h-9.95v-39.2h41.38c3.81,0,6.83,1.37,9.04,4.12c2.04,2.49,3.07,5.52,3.07,9.07c0,3.56-1.02,6.58-3.07,9.08 c-2.21,2.75-5.22,4.12-9.04,4.12h-3.81L1518.38,1484.58z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.17,1313.08c-0.43,20.33-17.04,36.59-37.38,36.61l-35.08,0.04l-0.26-243.69l-111.06,0.12l-10.08,0.16 l-34.17,81.99l-33.89-80.74l-25.17,0.48l-0.02-15.9c-0.03-24.39,19.73-44.17,44.1-44.2l163.14-0.18c0,0,74.17,5.23,78.69,90.86 C51.96,1195.33,51.1,1269.46,50.17,1313.08z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.28,1188.22l0.17,162.12c0.03,29.93-24.21,54.23-54.16,54.26l-166.52,0.18 c-49.45-1.69-71.6-67.02-71.6-67.02l-0.19-172.08c-0.03-31.75,25.68-57.51,57.43-57.54l17.56-0.02l-0.63,241.92l67.98-0.07 l-1.03-161.59l59.27,119.15l31.79-0.03L-99.28,1188.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-305.3,1484.58h-9.95v-23.87l-17.75,23.26l-17.75-23.26v23.87h-9.95v-39.2h10.45l17.25,22.65l17.33-22.65 h10.37V1484.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-225.19,1472.49c0,3.29-1.08,6.11-3.23,8.44c-2.32,2.43-5.25,3.65-8.79,3.65h-36.82v-9.15h36.82 c1.38,0,2.07-0.98,2.07-2.94c0-1.96-0.69-2.94-2.07-2.94H-264c-3.54,0-6.47-1.22-8.79-3.66c-2.21-2.29-3.32-5.08-3.32-8.39 c0-3.3,1.13-6.15,3.4-8.54c2.27-2.39,5.17-3.58,8.71-3.58h36.82v9.15h-36.9c-1.38,0-2.08,0.99-2.08,2.97c0,1.93,0.69,2.9,2.08,2.9 h26.84c3.54,0,6.48,1.22,8.81,3.65C-226.27,1466.39-225.19,1469.2-225.19,1472.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-140.61,1484.58h-9.95v-23.87l-17.75,23.26l-17.75-23.26v23.87H-196v-39.2h10.45l17.25,22.65l17.33-22.65 h10.36V1484.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-59.1,1484.58h-9.95v-12.43h-26.2V1463h26.2v-5.49c0-1.98-0.72-2.97-2.16-2.97H-99.4 c-1.38,0-2.07,0.99-2.07,2.97v27.08h-9.95v-27.1c0-3.3,1.12-6.14,3.36-8.52c2.24-2.38,5.13-3.58,8.67-3.58h28.19 c3.59,0,6.51,1.19,8.75,3.58c2.24,2.39,3.36,5.23,3.36,8.52V1484.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.18,1484.58H6.58l-21.31-21.96h25.62c1.82,0,2.74-1.35,2.74-4.04c0-2.69-0.91-4.04-2.74-4.04h-30.85v30.05 h-9.95v-39.2h41.38c3.81,0,6.83,1.37,9.04,4.12c2.04,2.49,3.07,5.52,3.07,9.07c0,3.56-1.02,6.58-3.07,9.08 c-2.21,2.75-5.22,4.12-9.04,4.12H7.66L20.18,1484.58z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-461.76,1313.08c-0.43,20.33-17.04,36.59-37.38,36.61l-35.08,0.04l-0.26-243.69l-111.06,0.12l-10.08,0.16 l-34.17,81.99l-33.89-80.74l-25.17,0.48l-0.02-15.9c-0.03-24.39,19.73-44.17,44.1-44.2l163.14-0.18c0,0,74.17,5.23,78.69,90.86 C-459.98,1195.33-460.84,1269.46-461.76,1313.08z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-611.21,1188.22l0.17,162.12c0.03,29.93-24.21,54.23-54.16,54.26l-166.52,0.18 c-49.45-1.69-71.6-67.02-71.6-67.02l-0.19-172.08c-0.03-31.75,25.68-57.51,57.43-57.54l17.56-0.02l-0.63,241.92l67.98-0.07 l-1.03-161.59l59.27,119.15l31.79-0.03L-611.21,1188.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-817.23,1484.58h-9.95v-23.87l-17.75,23.26l-17.75-23.26v23.87h-9.95v-39.2h10.45l17.25,22.65l17.33-22.65 h10.37V1484.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-737.13,1472.49c0,3.29-1.08,6.11-3.23,8.44c-2.32,2.43-5.25,3.65-8.79,3.65h-36.82v-9.15h36.82 c1.38,0,2.07-0.98,2.07-2.94c0-1.96-0.69-2.94-2.07-2.94h-26.78c-3.54,0-6.47-1.22-8.79-3.66c-2.21-2.29-3.32-5.08-3.32-8.39 c0-3.3,1.13-6.15,3.4-8.54c2.27-2.39,5.17-3.58,8.71-3.58h36.82v9.15h-36.9c-1.38,0-2.08,0.99-2.08,2.97c0,1.93,0.69,2.9,2.08,2.9 h26.84c3.54,0,6.48,1.22,8.81,3.65C-738.21,1466.39-737.13,1469.2-737.13,1472.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-652.55,1484.58h-9.95v-23.87l-17.75,23.26l-17.75-23.26v23.87h-9.95v-39.2h10.45l17.25,22.65l17.33-22.65 h10.36V1484.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-571.04,1484.58h-9.95v-12.43h-26.2V1463h26.2v-5.49c0-1.98-0.72-2.97-2.16-2.97h-28.19 c-1.38,0-2.07,0.99-2.07,2.97v27.08h-9.95v-27.1c0-3.3,1.12-6.14,3.36-8.52c2.24-2.38,5.13-3.58,8.67-3.58h28.19 c3.59,0,6.51,1.19,8.75,3.58c2.24,2.39,3.36,5.23,3.36,8.52V1484.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-491.76,1484.58h-13.6l-21.31-21.96h25.62c1.82,0,2.74-1.35,2.74-4.04c0-2.69-0.91-4.04-2.74-4.04h-30.85 v30.05h-9.95v-39.2h41.38c3.81,0,6.83,1.37,9.04,4.12c2.04,2.49,3.07,5.52,3.07,9.07c0,3.56-1.02,6.58-3.07,9.08 c-2.21,2.75-5.22,4.12-9.04,4.12h-3.81L-491.76,1484.58z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -273.5475,
    y1: 229.7008,
    x2: -21.2019,
    y2: 148.7597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-32.5,314.32c-0.93,20.32-17.95,36.16-38.28,35.67l-35.07-0.83l5.77-243.62l-111.03-2.63l-10.08-0.09 l-68.07-0.44l-25.17-0.14l0.38-15.89c0.57-24.39,20.81-43.67,45.18-43.1l163.09,3.87c0,0,74.02,7.07,76.41,92.78 C-27.8,196.66-30.5,270.74-32.5,314.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -275.9129,
    y1: 143.9955,
    x2: -214.3208,
    y2: 124.2395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-221.19,102.82 -257.38,183.94 -289.26,102.38 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -348.4819,
    y1: 294.6536,
    x2: -162.9809,
    y2: 235.1533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "-178.81,185.8 -182.65,347.88 -332.72,343.79 -329.75,182.22 -273.45,302.81 -241.67,303.56 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -483.1997,
    y1: 301.0457,
    x2: -224.3091,
    y2: 218.0053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-182.65,347.88c-0.71,29.92-25.55,53.61-55.49,52.9l-166.47-3.95c-49.4-2.92-69.92-68.76-69.92-68.76 l4.07-172.04c0.75-31.74,27.1-56.85,58.84-56.1l17.56,0.42l-6.62,241.83l67.96,1.61L-182.65,347.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -590.6863,
    y1: 516.4113,
    x2: -49.836,
    y2: 342.9309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-384.69,478.82h-9.95v-23.87l-17.75,23.26l-17.75-23.26v23.87h-9.95v-39.2h10.45l17.25,22.65l17.33-22.65 h10.37V478.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -583.002,
    y1: 540.3683,
    x2: -42.1516,
    y2: 366.888
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-304.59,466.73c0,3.29-1.08,6.11-3.23,8.44c-2.32,2.43-5.25,3.65-8.79,3.65h-36.82v-9.15h36.82 c1.38,0,2.07-0.98,2.07-2.94c0-1.96-0.69-2.94-2.07-2.94h-26.78c-3.54,0-6.47-1.22-8.79-3.66c-2.21-2.29-3.32-5.08-3.32-8.39 s1.13-6.15,3.4-8.54c2.27-2.39,5.17-3.58,8.71-3.58h36.82v9.15h-36.9c-1.38,0-2.08,0.99-2.08,2.97c0,1.93,0.69,2.9,2.08,2.9h26.84 c3.54,0,6.48,1.22,8.81,3.65C-305.67,460.63-304.59,463.44-304.59,466.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -575.3235,
    y1: 564.3069,
    x2: -34.4732,
    y2: 390.8267
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-220.01,478.82h-9.95v-23.87l-17.75,23.26l-17.75-23.26v23.87h-9.95v-39.2h10.45l17.25,22.65l17.33-22.65 h10.36V478.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -567.1158,
    y1: 589.8959,
    x2: -26.2654,
    y2: 416.4155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-138.49,478.82h-9.95v-12.43h-26.2v-9.15h26.2v-5.49c0-1.98-0.72-2.97-2.16-2.97h-28.19 c-1.38,0-2.07,0.99-2.07,2.97v27.08h-9.95v-27.1c0-3.3,1.12-6.14,3.36-8.52c2.24-2.38,5.13-3.58,8.67-3.58h28.19 c3.59,0,6.51,1.19,8.75,3.58c2.24,2.39,3.36,5.23,3.36,8.52V478.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -560.0767,
    y1: 611.8414,
    x2: -19.2263,
    y2: 438.3611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M-59.22,478.82h-13.6l-21.31-21.96h25.62c1.82,0,2.74-1.35,2.74-4.04c0-2.69-0.91-4.04-2.74-4.04h-30.85 v30.05h-9.95v-39.2h41.38c3.81,0,6.83,1.37,9.04,4.12c2.04,2.49,3.07,5.52,3.07,9.07c0,3.56-1.02,6.58-3.07,9.08 c-2.21,2.75-5.22,4.12-9.04,4.12h-3.81L-59.22,478.82z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -97.0386,
    y1: 368.4374,
    x2: 444.9819,
    y2: 194.5818,
    gradientTransform: "matrix(0.9997 -0.0248 0.0248 0.9997 -5.8929 7.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M518.55,328.32c-0.43,20.33-17.08,36.59-37.46,36.61l-35.16,0.04l-0.26-243.69l-111.31,0.12l-10.1,0.16 l-34.25,81.99l-33.96-80.74l-25.22,0.48l-0.02-15.9c-0.03-24.39,19.77-44.17,44.2-44.2l163.49-0.18c0,0,74.33,5.23,78.86,90.86 C520.34,210.58,519.48,284.7,518.55,328.32z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -95.6739,
    y1: 371.9827,
    x2: 446.1726,
    y2: 198.1829,
    gradientTransform: "matrix(0.9997 -0.0248 0.0248 0.9997 -5.8929 7.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M368.78,203.46l0.17,162.12c0.03,29.93-24.26,54.23-54.27,54.26l-166.88,0.18 c-49.56-1.69-71.76-67.02-71.76-67.02l-0.19-172.08c-0.03-31.75,25.74-57.51,57.55-57.54l17.6-0.02l-0.63,241.92l68.13-0.07 l-1.04-161.59l59.4,119.15l31.86-0.03L368.78,203.46z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.981,
    y1: 535.9394,
    x2: 498.826,
    y2: 362.1522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M163.39,498.25h-9.97v-23.87l-17.78,23.26l-17.78-23.26v23.87h-9.97v-39.2h10.47l17.29,22.65L153,459.05 h10.39V498.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.2354,
    y1: 559.9342,
    x2: 506.5404,
    y2: 386.157
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M243.67,486.16c0,3.29-1.08,6.11-3.24,8.44c-2.33,2.43-5.26,3.65-8.81,3.65h-36.9v-9.15h36.9 c1.38,0,2.08-0.98,2.08-2.94c0-1.96-0.69-2.94-2.08-2.94h-26.84c-3.55,0-6.48-1.22-8.81-3.66c-2.22-2.29-3.32-5.08-3.32-8.39 s1.13-6.15,3.41-8.54c2.27-2.39,5.18-3.58,8.73-3.58h36.9v9.15H204.7c-1.39,0-2.08,0.99-2.08,2.97c0,1.93,0.69,2.9,2.08,2.9h26.9 c3.55,0,6.49,1.22,8.83,3.65C242.58,480.05,243.67,482.87,243.67,486.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: -27.525,
    y1: 583.9199,
    x2: 514.2821,
    y2: 410.1327
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M328.43,498.25h-9.97v-23.87l-17.78,23.26l-17.79-23.26v23.87h-9.97v-39.2h10.47l17.29,22.65l17.37-22.65 h10.39V498.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -19.2881,
    y1: 609.56,
    x2: 522.5469,
    y2: 435.7639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M410.12,498.25h-9.97v-12.43h-26.26v-9.15h26.26v-5.49c0-1.98-0.72-2.97-2.16-2.97h-28.26 c-1.39,0-2.08,0.99-2.08,2.97v27.08h-9.97v-27.1c0-3.3,1.12-6.14,3.37-8.52c2.24-2.38,5.14-3.58,8.68-3.58h28.26 c3.6,0,6.52,1.19,8.77,3.58c2.24,2.39,3.37,5.23,3.37,8.52V498.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.2113,
    y1: 631.5466,
    x2: 529.6281,
    y2: 457.7491
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3692"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC6AAC"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M489.57,498.25h-13.63l-21.36-21.96h25.68c1.83,0,2.74-1.35,2.74-4.04c0-2.69-0.91-4.04-2.74-4.04h-30.91 v30.05h-9.97v-39.2h41.47c3.82,0,6.84,1.37,9.06,4.12c2.05,2.49,3.07,5.52,3.07,9.07c0,3.56-1.03,6.58-3.07,9.08 c-2.22,2.75-5.24,4.12-9.06,4.12h-3.82L489.57,498.25z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.4533e2683eefe2670539e49b0d431604.svg";
export { ForwardRef as ReactComponent };